import { defineMessages } from 'react-intl';

export const messages = defineMessages<{
  readonly ingredientKind: { readonly ingredient_kind: string };
}>({
  ingredientKind: {
    defaultMessage: `{ingredient_kind, select,
        bases {Bases}
        toppings {Toppings}
        premiums {Premiums}
        dressings {Dressings}
        bread {Bread}
        other {{ingredient_kind}}
    }`,
    description: 'Customization | Ingredients grid | Ingredient kinds',
  },
});
